import React from 'react';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	settingsPaneContentClasses,
	getSettingsPaneContentUtilityClass,
	SettingsPaneContentClasses,
	SETTINGS_PANE_CONTENT_CLASS_NAME,
} from './settingsPaneContentClasses';
import clsx from 'clsx';

type SettingsPaneContentAlign = 'center' | 'left' | 'right';

type SettingsPaneContentOwnerState = WithClasses<
	SettingsPaneContentClasses,
	{
		align?: SettingsPaneContentAlign;
	}
>;

const useUtilityClasses = (ownerState: SettingsPaneContentOwnerState) => {
	const {align, classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getSettingsPaneContentUtilityClass, classes);
};

const SettingsPaneContentRoot = styled('div', {
	name: SETTINGS_PANE_CONTENT_CLASS_NAME,
	slot: 'Root',
})(({theme, ownerState}) => ({
	display: 'flex',
	flexDirection: 'column',
	background: theme.palette.background.paper,
	padding: theme.spacing(2),
	width: '50%',
	flex: '0 0 auto',
	...(ownerState.align === 'center'
		? {
				alignItems: 'center',
		  }
		: ownerState.align === 'right'
		? {
				alignItems: 'flex-end',
		  }
		: null),
	[theme.breakpoints.down('sm')]: {
		paddingTop: 0,
		alignItems: 'flex-start',
	},
}));

export interface SettingsPaneContentProps
	extends React.PropsWithChildren<
			React.DetailedHTMLProps<
				React.HTMLAttributes<HTMLDivElement>,
				HTMLDivElement
			>
		>,
		WithClasses<
			SettingsPaneContentClasses,
			{
				align?: SettingsPaneContentAlign;
			}
		> {
	disablePadding?: boolean;
}

export const SettingsPaneContentPrimitive = ({
	classes: _classes,
	className,
	children,
	align,
	disablePadding,
	...props
}: SettingsPaneContentProps) => {
	const ownerState: SettingsPaneContentOwnerState = {
		classes: _classes,
		align,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<SettingsPaneContentRoot
			{...props}
			className={clsx(classes.root, className)}
			ownerState={ownerState}
			sx={{
				padding: disablePadding ? 0 : undefined,
			}}
		>
			{children}
		</SettingsPaneContentRoot>
	);
};

export const SettingsPaneContent = SettingsPaneContentPrimitive;

export default SettingsPaneContent;
